import React from 'react';
import MyCustomLogoFull from './logo/softwareone-logo.png';

const LogoFull = () => {
  return <img src={MyCustomLogoFull} style={{ height: '30px', width: 'auto' }} alt="" />;
};

export default LogoFull;
